import { Page } from 'components/organisms/Page';

import * as S from './PageSkeleton.style';

function SkeletonFooter({ isFirstPage }: { isFirstPage: boolean }) {
  return (
    <S.Footer>
      {isFirstPage ? (
        <>
          <S.Skeleton width={180} height={24} variant="rounded" />
          <S.Skeleton width={180} height={24} variant="rounded" />
          <S.Skeleton width={180} height={24} variant="rounded" />
        </>
      ) : (
        <S.FooterContainer>
          <S.Skeleton width="100%" height={6} variant="rounded" />
          <S.ActionsContainer>
            <S.Skeleton width={48} height={48} variant="circular" />
            <S.Skeleton width={123} height={32} variant="rounded" />
          </S.ActionsContainer>
        </S.FooterContainer>
      )}
    </S.Footer>
  );
}

function SkeletonHeader() {
  return (
    <S.Header>
      <S.LogoWrapper>
        <S.Skeleton width={132} height={32} variant="rounded" />
      </S.LogoWrapper>

      <S.HeaderContent>
        <S.Skeleton width={88} height={32} variant="rounded" />
        <S.Skeleton width={32} height={32} variant="circular" />
      </S.HeaderContent>
    </S.Header>
  );
}

function CardsSkeleton() {
  return (
    <S.CardsContainer>
      <S.Skeleton width="100%" variant="rounded" />
    </S.CardsContainer>
  );
}

export function PageSkeleton() {
  const path = window.location.pathname;
  const isFirstPage = ['/'].includes(path);

  return (
    <Page
      aria-busy="true"
      role="progressbar"
      header={<SkeletonHeader />}
      footer={<SkeletonFooter isFirstPage={isFirstPage} />}
    >
      <S.Section>
        <S.Skeleton width="60%" height={32} variant="rounded" />
        <S.Skeleton width="80%" height={40} variant="rounded" />
        <CardsSkeleton />
      </S.Section>
    </Page>
  );
}
